/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target date & time`)
};

const es_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha y hora objetivo`)
};

const de_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zieldatum & Uhrzeit`)
};

const nl_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doeldatum & -tijd`)
};

const fr_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date et heure cible`)
};

const it_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data e ora obiettivo`)
};

const pt_br2_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data e hora alvo`)
};

const pt_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data e hora alvo`)
};

const ja_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標日時`)
};

const zh_cd_target = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标日期与时间`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_target = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_target(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_target", locale)
	if (locale === "en") return en_cd_target(inputs)
	if (locale === "es") return es_cd_target(inputs)
	if (locale === "de") return de_cd_target(inputs)
	if (locale === "nl") return nl_cd_target(inputs)
	if (locale === "fr") return fr_cd_target(inputs)
	if (locale === "it") return it_cd_target(inputs)
	if (locale === "pt-BR") return pt_br2_cd_target(inputs)
	if (locale === "pt") return pt_cd_target(inputs)
	if (locale === "ja") return ja_cd_target(inputs)
	return zh_cd_target(inputs)
};